import React from 'react';
// import PropTypes from 'prop-types';

import VideoPartial from '../partials/Video';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/pages/show.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
};

const defaultProps = {};

const ShowPage = ({ page: { video = null } }) => {
    return (
        <div className={styles.container}>
            <div className={styles.inner}>
                <VideoPartial autoFullScreen url={video} />
            </div>
        </div>
    );
};

ShowPage.propTypes = propTypes;
ShowPage.defaultProps = defaultProps;

export default ShowPage;
